import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initFirebase } from "./firebase";

// Production builds get this from public/index.html's {{APP_TITLE}} (see
// scripts/apply-brand.js); this covers `npm start` dev mode too.
document.title = `${window.BRAND.name} Portal`;

const root = ReactDOM.createRoot(document.getElementById("root"));

initFirebase().then(() => {
  root.render(<React.StrictMode><App /></React.StrictMode>);
});
